import React from "react";
import { TextField } from "@material-ui/core";

const TextInputName = (props) => {
  return (
    <TextField
      disabled={props.disabled}
      fullWidth={props.fullWidth}
      label={props.label}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      name={props.name}
      value={props.value}
      type={props.type}
      onChange={props.onChange}
      onBlur={props.onBlur}
    />
  );
};
export default TextInputName;
